export default __webpack_public_path__ + "static/media/3536 utensils side.4a895fe0.png";